import { formatMoney } from 'accounting';

export const penceToPounds = (pence) => {
  return formatMoney(parseInt(pence, 10) / 100, {
    symbol: "£",
    precision: 2,
    format: {
      pos: "%s %v",
      neg: "%s -%v",
      zero: "%s  %v"
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/currency.js